import { render } from "./OlinaceCarousel.vue?vue&type=template&id=12cf4d36&scoped=true"
import script from "./OlinaceCarousel.vue?vue&type=script&lang=js"
export * from "./OlinaceCarousel.vue?vue&type=script&lang=js"

import "./OlinaceCarousel.vue?vue&type=style&index=0&id=12cf4d36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cf4d36"],['__file',"src/js/components/OlinaceCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12cf4d36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12cf4d36', __exports__)) {
    api.reload('12cf4d36', __exports__)
  }
  
  module.hot.accept("./OlinaceCarousel.vue?vue&type=template&id=12cf4d36&scoped=true", () => {
    api.rerender('12cf4d36', render)
  })

}


export default __exports__